module.exports = __webpack_public_path__ + "static/dioxane-1a46aa8ccedc01052909e24ec150410c.jpg";